exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\nh1[data-v-141f65e4] {\n  padding: 1.2rem 0 0.5rem;\n}\nh2[data-v-141f65e4] {\n  padding: 1.1rem 0 0.5rem;\n}\nh3[data-v-141f65e4] {\n  padding: 1rem 0 0.5rem;\n}\nh4[data-v-141f65e4] {\n  padding: 0.9rem 0 0.5rem;\n}\nh5[data-v-141f65e4] {\n  padding: 0.8rem 0 0.5rem;\n}\ntable[data-v-141f65e4] {\n  margin-top: 1rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-141f65e4","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/other/conditions/Conditions_en.vue
// module id = 2146
// module chunks = 0